export default "__VITE_ASSET__DjVXHPIL__"